import React, { Suspense } from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'

// eslint-disable-next-line
const withSuspense = <P extends object>(Component: React.ComponentType<P>): React.FC<P> => ({...props}) => {
  return (
    <Suspense fallback={<Dimmer active inverted><Loader size='big' /></Dimmer>}>
      <Component {...props as P} />
    </Suspense>
  )
}

export default withSuspense